module.exports = __webpack_public_path__ + "img/fusebox_online_emblem.1aaef1ee.svg";